import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom' 
import Header from "../Component/Header";
import {getPrincipalMessage} from'../Service/Api'
const PrincipalsMessage = () => { 
    useEffect(() => {
        document.title = 'Principals Message -  The Air Force School Subroto Park';  
    }, []);  
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true); 
    console.log(data);
 
    useEffect(() => {
        const fetchData = async () => {
            try {
                const principalData = await getPrincipalMessage();
               
                setData(principalData);
                
            } catch (error) {
                console.log("Data Error", error);
            } finally{
                setLoading(false)
            }
        };
        fetchData();
    }, []);
    const emptyData = [
       { id: 1}
   ];
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  About Us</li>
                 <li> Principal's Message</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Principal's Message</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                    {data.length > 0 ? data.map((item) => (
                        <div className="clearfix">
                         <img src={`https://webapi.entab.info/api/image/${item.attachments}`} alt="" className="col-md-4 float-md-end  left-img img-fluid"/>
                         <div className="mesdeskimg"> 
                            <h3> {item.name}</h3>
                            <h5> {item.category}</h5>
                         </div>
                         <div dangerouslySetInnerHTML={{ __html: item.message }} />
     
                         </div>
                     )) : emptyData.map((item) => (
                         <div className="clearfix"> 
                         <img src="https://webapi.entab.info/api/image/TAFS/public/Images/principal.jpg" className="col-md-4 float-md-end  left-img img-fluid"/>
                         <div className="mesdeskimg"> <h3>Mrs Lomina Rajiv</h3> <h5>  Principal  </h5></div>
                         <p>TAFS, founded in 1955, has evolved into an institution rich in its heritage and legacy. We're proud to have a student community, spread far and wide across the globe, who have contributed to the society and country, successful and competent, in various walks of life. In true spirit of our mission statement, we have over the last many decades striven to help our students to become responsible, harmonious and integrated individuals through our ever evolving curricular and co-curricular activities. In this 15 acres of our learning space we encourage our students to be creative and confident and learn through collaboration.</p>
                         <p>Our motto, 'Education Empowers', is so dynamic in its essence it is highly relevant irrespective of the changing times. Our objective is to empower our students with cognitive flexibility, problem solving and EQ skills. Our significant partnership with parents has helped us in this endeavour and we are truly obliged to them. </p>
                         <p>Ayn Rand once said, "The question isn't who's going to let me; it's who's going to stop me". There's no stopping an empowered TAFSian to dream deep, search for new trails and rise high to experience the skies. And yet be humble, kind and empathetic is this astounding journey that life is.</p>
                         </div> 
                         ))}
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default PrincipalsMessage

